<script setup lang="ts">
import type { SwiperContainer } from 'swiper/element';
import type { Swiper, SwiperOptions } from 'swiper/types';

defineProps<{ opts?: SwiperOptions }>();
defineSlots<{ default: () => void }>();

const swiperContainer = useTemplateRef<SwiperContainer>('swiperContainer');
const swiper = ref<Swiper>();
onMounted(async () => {
  await nextTick();
  swiper.value = swiperContainer.value?.swiper;
});
defineExpose({ swiper });
</script>

<template>
  <swiper-container ref="swiperContainer" v-bind="opts">
    <slot />
  </swiper-container>
</template>
